// extracted by mini-css-extract-plugin
module.exports = {"sumInputSuffix":"styles_sumInputSuffix__1w9nV","sumInputSuffixLarge":"styles_sumInputSuffixLarge__4d8LZ"};